<template>
    <transition
        name="fade"
        :enter-active-class="theme.fadeEnterActive"
        :enter-class="theme.fadeEnter"
        :enter-to-class="theme.fadeEnterTo"
        :leave-active-class="theme.fadeLeaveActive"
        :leave-class="theme.fadeLeave"
        :leave-to-class="theme.fadeLeaveTo"
    >
        <div v-if="active" :class="theme.wrapper">
            <div :class="theme.snackbar">
                <div :class="theme.messageContainer">
                    <v-text type="subheadling" :class="theme.message">
                        <slot :message="message">{{ message }}</slot>
                    </v-text>
                </div>
                <div :class="theme.actionContainer">
                    <slot name="action">
                        <v-button flat danger @click="$emit('close')">
                            закрыть
                        </v-button>
                    </slot>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
    import theme from './snackbar.scss'

    export default {
        name: 'snackbar',
        props: {
            message: String,
            active: {
                type: Boolean,
                default: false,
            },
            theme: {
                type: Object,
                default() {
                    return theme;
                }
            },
        },
    }
</script>


// WEBPACK FOOTER //
// Snackbar.vue?b5f3cdd0